import { render } from "./ProductsSwiper.vue?vue&type=template&id=32c7cc2f"
import script from "./ProductsSwiper.vue?vue&type=script&lang=js"
export * from "./ProductsSwiper.vue?vue&type=script&lang=js"

import "./ProductsSwiper.vue?vue&type=style&index=0&id=32c7cc2f&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__